/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-action-background-color: Specifies the component's background color.
* @prop --calcite-action-group-border-color: Specifies the component's border color when used in a `calcite-action-bar` or `calcite-action-menu`.
* @prop --calcite-action-group-columns: When `layout` is `"grid"`, specifies the component's grid-template-columns.
* @prop --calcite-action-group-gap: When `layout` is `"grid"`, specifies the component's gap.
* @prop --calcite-action-group-padding: [Deprecated] Use `--calcite-action-group-gap`. Specifies the component's padding.
*
*/
:host {
  display: flex;
  flex-direction: column;
  padding: 0px;
  background-color: transparent;
  border-color: var(--calcite-action-group-border-color, var(--calcite-color-border-3));
  border-style: solid;
  border-width: 0;
}

.container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

:host([columns="1"]) {
  --calcite-internal-action-group-columns: 1;
}

:host([columns="2"]) {
  --calcite-internal-action-group-columns: 2;
}

:host([columns="3"]) {
  --calcite-internal-action-group-columns: 3;
}

:host([columns="4"]) {
  --calcite-internal-action-group-columns: 4;
}

:host([columns="5"]) {
  --calcite-internal-action-group-columns: 5;
}

:host([columns="6"]) {
  --calcite-internal-action-group-columns: 6;
}

:host(:first-child) {
  padding-block-start: 0px;
}

:host([layout=horizontal]),
:host([layout=horizontal]) .container {
  flex-direction: row;
}

:host([layout=grid]) {
  display: grid;
}
:host([layout=grid]) .container {
  display: grid;
  place-content: stretch;
  background-color: transparent;
  grid-template-columns: repeat(var(--calcite-action-group-columns, var(--calcite-internal-action-group-columns, 3)), auto);
  gap: var(--calcite-action-group-gap, 1px);
  padding: var(--calcite-action-group-gap, 1px);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}